import React from 'react';
import Icon, { IconName } from 'components/icon/icon';
import cx from 'classnames';
import useWindowSize from 'lib/use-window-resize';
import lexemes from 'components/lexemes';

type HelplineNavigationProps = {
    prevIcon?: IconName;
    nextIcon?: IconName;
    onPrevClickHandler?: () => void;
    onNextClickHandler?: () => void;
    scrollDirection?: 1 | -1;
};

const HelplineNavigation: React.FC<HelplineNavigationProps> = (props) => {
    const {
        prevIcon = Icon.Name.ArrowLeft,
        nextIcon = Icon.Name.ArrowRight,
        onPrevClickHandler,
        onNextClickHandler,
        scrollDirection,
    } = props;

    const [mobileMode, setMobileMode] = React.useState<boolean | undefined>(undefined);

    const size = useWindowSize();

    React.useEffect(() => {
        setMobileMode(Boolean(size?.width && size.width < 600));
    }, [size]);

    const classNames = {
        block: cx({
            'helpline-navigation': true,
            'has-mobile-mode': mobileMode,
        }),
        arrowPrev: cx({
            'helpline-navigation__arrow': true,
            'helpline-navigation__arrow--prev': true,
            'has-hover': onPrevClickHandler,
            'show-on-mobile': mobileMode && scrollDirection === -1,
            'hide-on-mobile': mobileMode && scrollDirection === 1,
        }),
        arrowNext: cx({
            'helpline-navigation__arrow': true,
            'helpline-navigation__arrow--next': true,
            'has-hover': onNextClickHandler,
            'show-on-mobile': mobileMode && scrollDirection === 1,
            'hide-on-mobile': mobileMode && scrollDirection === -1,
        }),
    };

    // hidden=true completely hides block from screen readers (as it's useless), but CSS shows it back for screens
    return (
        <div className={classNames.block} hidden={true}>
            <button className={classNames.arrowPrev} onClick={onPrevClickHandler}>
                <Icon
                    name={prevIcon}
                    size="stretch"
                    a11y={{
                        label: lexemes.helpLines.lxNavigationBackwardA11yLabel(),
                    }}
                />
            </button>
            <button className={classNames.arrowNext} onClick={onNextClickHandler}>
                <Icon
                    name={nextIcon}
                    size="stretch"
                    a11y={{
                        label: lexemes.helpLines.lxNavigationForwardA11yLabel(),
                    }}
                />
            </button>
        </div>
    );
};

export default HelplineNavigation;
